import React from 'react';
// components
import Modal from 'shared/modals/Modal';
import HoldsForm from '../../forms/HoldsForm';

const HoldsModal = ({
  onClose,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {
  return (
    <Modal isOpen={true} title={`${initialValues.hold ? 'Edit' : 'Add'} Hold for MR #${initialValues.id}`} handleClose={onClose} containerStyle='medium'>
      <section className={`ccc-standard-form ${isSubmitting ? 'hide-overflow' : ''}`}>
        <HoldsForm data={initialValues} onClose={onClose} setSubmitting={setSubmitting} />
      </section>
    </Modal>
  );
};

export default HoldsModal;
